import Vue from 'vue'
import Router from 'vue-router'
import Intro from './pages/Intro.vue'
import Edit from './pages/Edit.vue'
import View from './pages/View.vue'

const redirectPath = window && window.location &&
  window.location.href && window.location.href.includes('spinneybeck')
  ? '/spinneybeck'
  : '/filzfelt'

const routes = [
  { path: '/', redirect: redirectPath },

  { name: 'intro', path: '/:brand(filzfelt|spinneybeck)', component: Intro, props: true },
  { name: 'edit', path: '/:id?/:slug?/edit', component: Edit, props: true },
  { name: 'view', path: '/:id?/:slug?/view', component: View, props: true },

  { path: '*', redirect: '/' }
]

Vue.use(Router)

export default new Router({
  mode: process.env.VUE_ROUTER_MODE || 'history',
  routes
})



// WEBPACK FOOTER //
// ./src/client/router.js